export function WidgetPreview() {
  return (
    <div className="sticky top-6">
      <section>
        <div id="widget" className="w-full h-[600px] rounded-xl border-gray-100 overflow-hidden shadow-lg" />
      </section>
    </div>
  )
}
